import classNames from 'classnames'

import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { doubleBannerRevealAnimation } from './animations'
import { Section, WPLink } from '@/types'

type Banner = Partial<{
  variant: string
  title: string
  title_component: TypographyProps['component']
  paragraph: string
  button: WPLink
}>

type DoubleBannerProps = Section & {
  collection?: Banner[]
}

const DoubleBanner = ({ collection, ...props }: DoubleBannerProps) => {
  return (
    <Motion animation={doubleBannerRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid>
              {collection?.map(
                (
                  { variant, title, title_component, paragraph, button },
                  index
                ) => (
                  <div
                    key={`banner-${index}`}
                    className="col-span-2 md:col-span-6 lg:col-span-6"
                    data-motion-banner
                  >
                    <div
                      className={classNames('h-full rounded-xs shadow-3xl', {
                        'bg-pink': variant === 'pink',
                        'bg-cyan': variant === 'cyan'
                      })}
                    >
                      <div className={classNames('grid gap-md p-sm')}>
                        {title ? (
                          <Typography
                            variant="h3"
                            component={title_component}
                            className="text-white [&_em]:text-pink"
                          >
                            {title}
                          </Typography>
                        ) : null}

                        {paragraph ? (
                          <Typography
                            variant="body"
                            paragraph
                            className="text-white"
                          >
                            {paragraph}
                          </Typography>
                        ) : null}

                        {button ? (
                          <div>
                            <Button
                              href={button?.url}
                              link
                              dark
                              variant="contained"
                              external={button?.target === '_blank'}
                              color={variant}
                            >
                              {button?.title}
                            </Button>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                )
              )}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default DoubleBanner
